import { render, staticRenderFns } from "./sysServer.vue?vue&type=template&id=65be551a&scoped=true"
import script from "./sysServer.vue?vue&type=script&lang=js"
export * from "./sysServer.vue?vue&type=script&lang=js"
import style0 from "./sysServer.vue?vue&type=style&index=0&id=65be551a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65be551a",
  null
  
)

export default component.exports